import axios from "axios";

export const payerService = {
    getPayersService: (params) =>
        axios.get("/payers", {auth: true, params: {...params}}),

    getPayerSingleService: (payerId, params) =>
        axios.get(`/payers/${payerId}`, {auth: true, params: {...params}}),

    deletePayerService: (id) => axios.delete(`/payers/${id}`, {auth: true}),
    addPayerService: (body) => axios.post("/payers", body, {auth: true}),
    editPayerService: (id, body) =>
        axios.patch(`/payers/${id}`, body, {auth: true}),

    changeStatusPayerService: (id, body) =>
        axios.patch(`/payers/${id}/status`, body, {auth: true}),

    /** Connect Momentm to Payer */
    getMomentmToPayerService: (id) =>
        axios.get(`/momentm/${id}`, {auth: true}),

    connectMomentmToPayerService: (body) =>
        axios.post(`/momentm`, body, {auth: true}),

    editMomentmToPayerService: (payerId, body) =>
        axios.patch(`/momentm/${payerId}`, body, {auth: true}),

    editMomentmStatusService: (payerId, body) =>
        axios.patch(`/momentm/${payerId}/status`, body, {auth: true}),
    /** End */

    /** Appt Time Rules*/
    enablePayerApptTimeService: (payerId, body) =>
        axios.patch(`/payers/${payerId}/timeRules/enable`, body, {auth: true}),

    editPayerTimeRulesService: (payerId, body) =>
        axios.patch(`/payers/${payerId}/timeRules`, body, {auth: true}),
    /** End */

    // Payer Rates
    getPayersRatesService: (params) =>
        axios.get("/rates", {auth: true, params: {...params}}),
    deletePayerRatesService: (id) => axios.delete(`/rates/${id}`, {auth: true}),
    addPayerRatesService: (body) => axios.post("/rates", body, {auth: true}),
    editPayerRatesService: (id, body) =>
        axios.patch(`/rates/${id}`, body, {auth: true}),
};
